import { call } from "./calls";

export const UserPreferences = {
    get: () => call("/UserPreferences"),
    save: (prefs) => call("/UserPreferences", "POST", prefs),
    changeActiveTheme: (themeName) => call("/UserPreferences", "POST", {action:"changeTheme",activeTheme: themeName})
}